import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { convertDateFormatInputDate, formatDateIL } from '../../util/formatsForDate';
import { FaUpload, FaWallet } from 'react-icons/fa';
import { useUser } from '../../App/copmponents/UserProvider';
import Select from "react-select"

const UserDetails = ({isEdit}) => {
    // const {setUserDetails } = useUser();
    const userCtx = useUser() || {};
    const setUserDetails = userCtx.setUserDetails ?? (() => {});
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isEditing, setIsEditing] = useState(isEdit?true:false);
    const [formData, setFormData] = useState({});
    // const [imgFacePicture, setImgFacePicture] = useState(null);
    const [citysList, setcitysList] = useState([]);
    const [streetList, setstreetList] = useState([]);
    const arrJobsPlace = ["עצמאי", "עסק", "שכיר במוסד ממשלתי", "שכיר ברשות מקומית", "שכיר צה\"ל", "שכיר בחברה לייעוץ בטיחות", "שכיר בקיבוץ/מקום עבודה שיתופי", "שכיר במקום עבודה בפרטי", "אחר"]
    const imgInputRef = useRef(null);
    const [dataFiles, setDataFiles] = useState({
        imgFacePicture: null,

    })
    const [errors, setErrors] = useState({
        email: '',
        mainPhone: '',
        additionalPhone: '',
        gender: '',
        city: '',
        street: '',
        job: '',
        region: ''
    });
    useEffect(() => {
        getStreets(formData.city)
    }, [formData?.city])
    // useEffect(() => { console.log(formData) }, [formData])
    
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#60a5fa ',
            borderColor: '#1e40af ',

            minHeight: '20px',
            maxWidth: '150px',
            // height: '20px',
            padding: '2px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '20px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '20px',
        }),
    };

    const fetchUser = async () => {
        try {
            const res = await axios.get('dashboard/member/member_self');
            setUser(res.data);
             if(isEdit)
             {  setFormData({
            dateBorn: convertDateFormatInputDate(res.data?.dateBorn),
            street: res.data?.street,
            apartmentNumber: res.data?.apartmentNumber,
            houseNumber: res.data?.houseNumber,
            city: res.data?.city,
            email: res.data?.email,
            mainPhone: res.data?.mainPhone,
            additionalPhone: res.data?.additionalPhone,
            gender: res.data?.gender,
            job: res.data?.job,
            region: res.data?.region,
            imgFacePicture: ""
        })}
            console.log(res.data)
            if (res?.data?.city) {
                loadStreetsInBackground(res.data.city);
               
            }
         
        } catch (err) {
            console.error(err);
            setError('שגיאה בטעינת הנתונים');
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {

        fetchUser();
        
    }, []);

const loadStreetsInBackground = async (cityName) => {
  try {
    const response = await axios.get(`auth/all_street/${cityName}`);
    if (response.status === 200) {
      setstreetList(response.data);
    }
  } catch (err) {
    console.error("שגיאה בהבאת רחובות", err);
  }
};
    useEffect(() => {
        getCity();
    }, []);

    const handleFileChange = (event) => {
        const { name } = event?.target
        const file1 = event.target.files[0];

        // setFormData({
        //     ...formData,
        //     [name]: event.target.value
        // })
        if (file1) {

            console.log(name, file1)
            setDataFiles({ [name]: file1 })
            const reader = new FileReader();
            reader.onload = (e) => {
                // setPreviewUrl(e.target.result);
                setFormData({ ...formData, [name]: e.target.result });

            };

            reader.readAsDataURL(file1);


        }
    }

    // const handleStreets = async () => {
    //     if (formData.city) {
    //         getStreets(formData.city).then(() => {
    //             setFormData(prev => ({
    //                 ...prev,
    //                 street: '',
    //                 region: ''
    //             }));
    //         });
    //     }
    //     else {
    //         setstreetList([]);
    //         setFormData(prev => ({
    //             ...prev,
    //             region: ''
    //         }
    //         ));
    //     }
    // }
    const getCity = async () => {
        try {
            const response = await axios.get('auth/all_city');
            if (response.status === 200) {
                setcitysList(response.data);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const getStreets = async (cityName) => {
        try {
             if (cityName) {
            const response = await axios.get(`auth/all_street/${cityName}`);
            if (response.status === 200) {
                setstreetList(response.data);
            }
              }
              else { setstreetList([]) 
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        // if (name == "city")
        //     handleStreets()
    };

    // const handleImageChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) setImgFacePicture(file);
    // };
    const handleChangeSelect = (selectedOption, name) => {
        // console.log(selectedOption)
        setFormData({
            ...formData,
            [name]: selectedOption?.value
            ,
        })
        // if (name == "city")
        //     handleStreets()
    }
    const validateForm = () => {
        const newErrors = {};
        const phoneRegex = /^0\d{1,2}-?\d{7}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(formData.email || '')) {
            newErrors.email = 'כתובת אימייל אינה תקינה';
        }

        if (!phoneRegex.test(formData.mainPhone || '')) {
            newErrors.mainPhone = 'מספר טלפון ראשי אינו תקין';
        }

        if (formData.additionalPhone && !phoneRegex.test(formData.additionalPhone)) {
            newErrors.additionalPhone = 'מספר טלפון נוסף אינו תקין';
        }

        if (!formData.gender) {
            newErrors.gender = 'יש לבחור מגדר';
        }

        if (!formData.city) {
            newErrors.city = 'יש לבחור עיר';
        }

        if (!formData.street) {
            newErrors.street = 'יש לבחור רחוב';
        }

        if (!formData.region) {
            newErrors.region = 'יש לבחור אזור';
        }
        if (!formData.job) {
            newErrors.job = 'יש לבחור סטטוס';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    const handleSubmit = async () => {
        try {

            if (!validateForm()) return;
            const formData1 = new FormData();
            formData1.append(
                'memberDetails',
                JSON.stringify({

                    dateBorn: formData?.dateBorn,
                    job: formData?.job,
                    street: formData?.street,
                    apartmentNumber: Number(formData?.apartmentNumber),
                    houseNumber: Number(formData?.houseNumber),
                    city: formData?.city,
                    email: formData?.email,
                    mainPhone: `${formData?.mainPhone}`,
                    additionalPhone: formData?.additionalPhone,
                    gender: formData.gender,
                    region: formData.region,
                })
            );

            formData1.append('img_face_picture', dataFiles?.imgFacePicture);







            const res = await axios.put('dashboard/member/member_self', formData1,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })

            alert('הנתונים עודכנו בהצלחה');
            await fetchUser();

            // setUserDetails({
            //     userName: `${user.firstName} ${user.lastName}`,
            //     avatarUrl: user.imgFacePicture ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${user.imgFacePicture}?t=${Date.now()}` : ""
            //     });

            setUserDetails((prev) => ({
                ...(prev || {}),
                userName: `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
                avatarUrl: user?.imgFacePicture
                    ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${user.imgFacePicture}?t=${Date.now()}`
                    : ""
                }));
            setIsEditing(false);
        } catch (error) {
            console.error(error);
            alert('שגיאה בעדכון הנתונים');
        }
    };
    const handleCancel = () => {
        if (user) {
            setFormData({
                dateBorn: user.dateBorn,
                street: user.street,
                apartmentNumber: user.apartmentNumber,
                houseNumber: user.houseNumber,
                city: user.city,
                email: user.email,
                mainPhone: user.mainPhone,
                additionalPhone: user.additionalPhone,
                gender: user.gender,
                job: user.job,
                region: user.region,
                imgFacePicture: user?.imgFacePicture
            });
            setErrors({
                email: '',
                mainPhone: '',
                additionalPhone: '',
                gender: '',
                city: '',
                street: '',
                job: '',
                region: ''
            })
        }
        setIsEditing(false);
    };
    const handleTakePhotoClick = (ref) => {
        if (ref == "imgInputRef")
            imgInputRef.current.click();


    };

    const handleEdit = async () => {

        setFormData({
            dateBorn: convertDateFormatInputDate(user?.dateBorn),
            street: user?.street,
            apartmentNumber: user?.apartmentNumber,
            houseNumber: user?.houseNumber,
            city: user?.city,
            email: user?.email,
            mainPhone: user?.mainPhone,
            additionalPhone: user?.additionalPhone,
            gender: user?.gender,
            job: user?.job,
            region: user?.region,
            imgFacePicture: ""
        });

        setIsEditing(true)
    }

    if (loading) return <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-gray-500" />
      </div>

    if (error) return <p>{error}</p>;
    return (
        <div className="p-6 bg-white shadow-md rounded-md space-y-6">
            <div className="flex items-center justify-between gap-4 mb-6">
                {!isEditing ? (
                    <button onClick={handleEdit} className="bg-blue-600 text-white px-4 py-2 rounded">ערוך</button>
                ) : (
                    <div className="space-x-3 rtl:space-x-reverse">
                        <button onClick={handleSubmit} className="bg-green-600 text-white px-4 py-2 rounded">שמור</button>
                        <button onClick={handleCancel
                        } className="bg-gray-400 text-white px-4 py-2 rounded">בטל</button>
                    </div>
                )}

                {/* יתרה */}
                <div dir="rtl" className="flex items-center gap-2 w-fit translate-y-1 rounded-full bg-blue-50 border border-blue-200 px-4 py-1.5 shadow-sm">
                    <FaWallet className="text-blue-600 text-sm" />
                    <span className="text-sm font-semibold text-gray-700">יתרה:</span>
                    <span className={`text-sm font-bold ${user?.balance != null && Number(user.balance) < 0 ? 'text-red-600' : 'text-blue-700'}`}>
                        {user?.balance != null ? `${Number(user.balance).toLocaleString('he-IL')} ₪` : '—'}
                    </span>
                </div>
            </div>

            {/* פרטים אישיים */}
            <div>
                <h2 className="text-xl font-bold border-b pb-2 mb-4 text-right">פרטים אישיים</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-right" style={{ direction: "rtl" }}>
                    <p><span className="font-semibold text-gray-700">מספר חבר:</span> {user?.number}</p>
                    <p><span className="font-semibold text-gray-700">תאריך הרשמה:</span> {formatDateIL(user?.dateRegister)}</p>
                    <p><span className="font-semibold text-gray-700">שם פרטי:</span> {user?.firstName}</p>
                    <p><span className="font-semibold text-gray-700">שם משפחה:</span> {user?.lastName}</p>
                    <p><span className="font-semibold text-gray-700">ת.ז.:</span> {user?.idNumber}</p>

                    <p><span className="font-semibold text-gray-700">תאריך לידה:</span> {!isEditing ? formatDateIL(user?.dateBorn) : <input name="dateBorn" type='date' value={formData?.dateBorn} onChange={handleChange} className='bg-blue-400 border border-blue-800 p-1 rounded-md'></input>}</p>
                    <p><span className="font-semibold text-gray-700">מקום עבודה:</span> {!isEditing ? user?.job :
                        <select name="job" value={formData?.job || ''} onChange={handleChange} className='bg-blue-400 border border-blue-800 p-1 rounded-md'>
                            <option value="">בחר מיקום עבודה</option>
                            {arrJobsPlace.map((job, idx) => (
                                <option key={idx} value={job}>{job}</option>
                            ))}
                        </select>
                    }
                        {errors.job && <div className="text-red-600 text-sm mt-1">{errors.job}</div>}</p>
                    <p>
                        <span className="font-semibold text-gray-700 ml-1">מגדר:</span>
                        {!isEditing ? user?.gender : (
                            <>
                                <select name="gender" value={formData?.gender || ''} onChange={handleChange} className='bg-blue-400 border border-blue-800 p-1 rounded-md'>
                                    <option value="">בחר</option>
                                    <option value="זכר">זכר</option>
                                    <option value="נקבה">נקבה</option>
                                    {/* <option value="לא ידוע">לא ידוע</option> */}
                                </select>
                                {errors.gender && <div className="text-red-600 text-sm mt-1">{errors.gender}</div>}
                            </>
                        )}
                    </p>
                </div>
            </div>

            {/* כתובת */}
            <div>
                <h2 className="text-xl font-bold border-b pb-2 mb-4 text-right">כתובת</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-right" style={{ direction: "rtl" }}>
                    <p>
                        <span className="font-semibold text-gray-700 ml-1">עיר:</span>
                        {!isEditing ? user?.city : (
                            <>
                                {/* <select name="city" value={formData?.city || ''} onChange={handleChange} className='bg-blue-400 border border-blue-800 p-1 rounded-md'>
                                    <option value="">בחר עיר</option>
                                    {citysList.map((city, idx) => (
                                        <option key={idx} value={city}>{city}</option>
                                    ))}
                                </select> 
                                 */}
                                {/* <Select className='bg-blue-400 border border-blue-800 p-1 rounded-md' */}
                                {/* <Select 
                            options={citysList?.map((item) => { return { value: item, label: item } })}
                            placeholder="חפש..."
                            isClearable
                            isSearchable
                            styles={customStyles}
                            maxMenuHeight={100}
                            value={formData?.city ?
                                { value: formData.city, label: formData.city } : null}
                            onChange={(e) => {handleChangeSelect(e, 'city')
                                setFormData((prev)=>({...prev, street:""}))}
                            }
                        ></Select> */}
                                <Select
                                    options={citysList?.map((item) => { return { value: item, label: item } })}
                                    value={formData?.city ?
                                        { value: formData.city, label: formData.city } : null}
                                    onChange={(selectedOption) => setFormData(prev => ({ ...prev, city: selectedOption?.value || '', street: '', region: '' }))}
                                    placeholder="בחר עיר"
                                    isClearable
                                    classNamePrefix="react-select"
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            backgroundColor: '#bfdbfe', // Tailwind bg-blue-400
                                            borderColor: '#1e40af',     // Tailwind border-blue-800
                                            direction: 'rtl',
                                            textAlign: 'right',
                                            maxWidth: '180px'
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            direction: 'rtl',
                                            textAlign: 'right'
                                        })
                                    }}
                                />
                                {errors.city && <div className="text-red-600 text-sm mt-1">{errors.city}</div>}
                            </>
                        )}
                    </p>
                    <p>
                        <span className="font-semibold text-gray-700 ml-1">רחוב:</span>
                        {!isEditing ? user?.street : (
                            <>
                                {/* <select name="street" value={formData?.street || ''} onChange={handleChange} className='bg-blue-400 border border-blue-800 p-1 rounded-md'>
                                    <option value="">בחר רחוב</option>
                                    {streetList.map((street, idx) => (
                                        <option key={idx} value={street}>{street}</option>
                                    ))}
                                </select> */}
                                 <Select className='  grid col-span-5 p-0 text-right'
                                                            options={streetList?.map((item) => { return { value: item, label: item } })}
                                                            placeholder="חפש..."
                                                            isClearable
                                                            isDisabled={!formData?.city}
                                                            // isSearchable
                                                             styles={{
                                        control: (base) => ({
                                            ...base,
                                            backgroundColor: '#bfdbfe', // Tailwind bg-blue-400
                                            borderColor: '#1e40af',     // Tailwind border-blue-800
                                            direction: 'rtl',
                                            textAlign: 'right',
                                            maxWidth: '180px'
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            direction: 'rtl',
                                            textAlign: 'right'
                                        })
                                    }}
                                                            maxMenuHeight={100}
                                                            // name="street"
                                                            value={formData?.street ?
                                                                { value: formData.street, label: formData.street } : null}
                                                            onChange={(e) => handleChangeSelect(e, 'street')}
                                                        // value={formData.street}
                                                        // onChange={handleChange}
                                                        ></Select>
                                {errors.street && <div className="text-red-600 text-sm mt-1">{errors.street}</div>}
                            </>
                        )}
                    </p>



                    <p><span className="font-semibold text-gray-700">מספר בית:</span> {!isEditing ? user?.houseNumber : <input name="houseNumber" value={formData?.houseNumber || ''} onChange={handleChange} className='bg-blue-400 border border-blue-800 p-1 rounded-md' />}</p>
                    <p><span className="font-semibold text-gray-700">מספר דירה:</span> {!isEditing ? user?.apartmentNumber : <input name="apartmentNumber" value={formData?.apartmentNumber || ''} onChange={handleChange} className='bg-blue-400 border border-blue-800 p-1 rounded-md' />}</p>
                    {/* <p><span className="font-semibold text-gray-700">איזור:</span> {user?.region}</p> */}

                    <p>
                        <span className="font-semibold text-gray-700 ml-1">איזור:</span>
                        {!isEditing ? user?.region : (
                            <>
                                <select name="region" value={formData?.region || ''} onChange={handleChange} className='bg-blue-400 border border-blue-800 p-1 rounded-md'>
                                    <option value="">בחר</option>
                                    <option value="ירושלים">ירושלים</option>
                                    <option value="המרכז">המרכז</option>
                                    <option value="הצפון">הצפון</option>
                                    <option value="תל אביב">תל אביב</option>
                                    <option value="הדרום">הדרום</option>
                                    <option value="אזור יהודה ושומרון">אזור יהודה ושומרון</option>
                                    <option value="חיפה">חיפה</option>
                                </select>
                                {errors.region && <div className="text-red-600 text-sm mt-1">{errors.region}</div>}
                            </>
                        )}
                    </p>
                </div>
            </div>

            <div>
                <h2 className="text-xl font-bold border-b pb-2 mb-4 text-right">פרטי התקשרות </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-right" style={{ direction: "rtl" }}>
                    <p>
                        <span className="font-semibold text-gray-700 ml-1">דוא"ל:</span>
                        {!isEditing ? user?.email : (
                            <>
                                <input
                                    name="email"
                                    value={formData?.email || ''}
                                    onChange={handleChange}
                                    className='bg-blue-400 border border-blue-800 p-1 rounded-md min-w-48'
                                />
                                {errors.email && <div className="text-red-600 text-sm mt-1">{errors.email}</div>}
                            </>
                        )}
                    </p>

                    <p>
                        <span className="font-semibold text-gray-700 ml-1">טלפון ראשי:</span>
                        {!isEditing ? user?.mainPhone : (
                            <>
                                <input
                                    name="mainPhone"
                                    value={formData?.mainPhone || ''}
                                    onChange={handleChange}
                                    className='bg-blue-400 border border-blue-800 p-1 rounded-md'
                                />
                                {errors.mainPhone && <div className="text-red-600 text-sm mt-1">{errors.mainPhone}</div>}
                            </>
                        )}
                    </p>

                    <p>
                        <span className="font-semibold text-gray-700">טלפון נוסף:</span>
                        {!isEditing ? user?.additionalPhone : (
                            <>
                                <input
                                    name="additionalPhone"
                                    value={formData?.additionalPhone || ''}
                                    onChange={handleChange}
                                    className='bg-blue-400 border border-blue-800 p-1 rounded-md'
                                />
                                {errors.additionalPhone && <div className="text-red-600 text-sm mt-1">{errors.additionalPhone}</div>}
                            </>
                        )}
                    </p>

                    {/* 
                    <p>{user?.email} <span className="font-semibold text-gray-700 ">:דוא"ל</span> </p>
                    <p><span className="font-semibold text-gray-700">טלפון ראשי:</span> {user?.mainPhone}</p>
                    <p><span className="font-semibold text-gray-700">טלפון נוסף:</span> {user?.additionalPhone}</p> */}
                </div>
            </div>

            <div>
                <h2 className="text-xl font-bold border-b pb-2 mb-4 text-right">אישור כשירות </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-right" style={{ direction: "rtl" }}>
                    <p><span className="font-semibold text-gray-700" >מספר נ.ש.:</span> {user?.nsnumber}</p>
                </div>
            </div>



            <div className="mt-10">
                <h2 className="text-xl font-bold text-right mb-4">קבצים מצורפים</h2>

                {/* תמונת פנים */}
                {user?.imgFacePicture && (
                    <div className="border p-4 mb-4 bg-gray-200 rounded-md text-center flex flex-col">
                        {isEditing && <button type="button" className='flex text-[10px] w-fit place-self-end py-1 px-2 items-baseline bg-blue-400 border border-blue-800 my-2 rounded-md text-white cursor-pointer' onClick={() => handleTakePhotoClick("imgInputRef")}>
                            <FaUpload />
                            <p className='mr-2'>העלה קובץ</p>
                        </button>}
                        {isEditing && <input type="file" id="imgFacePicture" name="imgFacePicture"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                            ref={imgInputRef}
                            accept="image/*"
                        //  capture="environment"
                        />}
                        <p className="mb-2 font-semibold">תמונת פנים</p>
                        {isEditing && formData.imgFacePicture ?
                            <img
                                src={formData.imgFacePicture}
                                alt="תמונת פנים"
                                className="mx-auto max-w-[150px] max-h-[150px] object-contain border"

                            /> :
                            <img
                                // src={`https://archivebureau.s3.eu-west-3.amazonaws.com/${user?.imgFacePicture}`}
                                src={`https://archivebureau.s3.eu-west-3.amazonaws.com/${user?.imgFacePicture}?t=${Date.now()}`}
                                alt="תמונת פנים"
                                className="mx-auto max-w-[150px] max-h-[150px] object-contain border"

                            />
                        }
                    </div>
                )}



                {/* חתימה */}
                {user?.imgSignature && (
                    <div className="border p-4 bg-gray-200 rounded-md text-center">
                        <p className="mb-2 font-semibold">חתימה</p>
                        <img
                            src={`https://archivebureau.s3.eu-west-3.amazonaws.com/${user.imgSignature}`}
                            alt="חתימה"
                            className="mx-auto max-w-[150px] max-h-[150px] object-contain border"
                        />
                    </div>
                )}
            </div>
        </div>


    );
}

export default UserDetails